<div 
  class="view-scrubber" 
  [ngClass]="{'view-scrubber--draggable': showHandle}"
  #scrubber>
  <div class="view-scrubber__track" #track>
    <div class="view-scrubber__bar" #bar></div>
  </div>

  <div 
    #handle
    class="view-scrubber__handle" 
    cdkDrag 
    cdkDragLockAxis="x"
    cdkDragBoundary=".view-scrubber"
    [cdkDragFreeDragPosition]="dragPosition"
    (cdkDragMoved)="handleDragMoved($event)"
    [ngClass]="{'view-scrubber__handle--hide': !showHandle, 'view-scrubber__handle-touch': canTouch$ | async }"></div>
</div>